module.exports = __webpack_public_path__ + "media/landing_page/landing_page_bg-min-4-51b638d6.jpg";